export default __webpack_public_path__ + "static/testimonialOvalLeft-6b60e9538ee8b3fd9c4a2efed1a9a072.png";